import {withForm} from "components/forms/form";
import {getUserInterestFormData} from "components/forms/InterestForm/helpers";
import {FormattedMessage} from "react-intl";
import {Counter} from "@atoms/FormElements/Counter";
import {getFormattedMessage} from "features/services/utils/language-helper";
import {FILTERS_MAX_ROOMS, FILTERS_MIN_ROOMS} from "features/search/filters/constants";
import * as React from "react";
import {useState} from "react";

export const BedRoomCounter = withForm({
    defaultValues: getUserInterestFormData(null),
    render: function Render({form}) {

        const [minRooms, setMinRooms] = useState<number>(0);
        const [maxRooms, setMaxRooms] = useState<number>(0);

        const onMinRoomsChange = (count: number) => {
            setMinRooms(count);
            form.setFieldValue('minNumberOfRooms', count)

            if (count > maxRooms) {
                setMaxRooms(count);
                form.setFieldValue('maxNumberOfRooms', count);
            }
        }

        const onMaxRoomsChange = (count: number) => {
            setMaxRooms(count);
            form.setFieldValue('maxNumberOfRooms', count)


            if (count < minRooms) {
                setMinRooms(count);
                form.setFieldValue('minNumberOfRooms', count);
            }
        }

        return (
            <div>
                <div className="room-selector bedroom-counter">
                    <div className="room-selector__counter-container">
                        <span><FormattedMessage id="jm.components.InterestForm.minBedRooms"/></span>
                        <Counter
                            id={getFormattedMessage('jm.components.InterestForm.minBedRooms')}
                            onChange={onMinRoomsChange}
                            value={minRooms}
                            minValue={0}
                            maxValue={FILTERS_MAX_ROOMS}
                            maxValueAffix="+"
                        />
                    </div>

                    <div className="room-selector__divider">
                        <span>-</span>
                    </div>

                    <div className="room-selector__counter-container">
                        <span><FormattedMessage id="jm.components.InterestForm.maxBedRooms"/></span>

                        <Counter
                            id={getFormattedMessage('jm.components.InterestForm.maxRooms')}
                            onChange={onMaxRoomsChange}
                            value={maxRooms}
                            minValue={(minRooms !== FILTERS_MIN_ROOMS) ? minRooms : FILTERS_MIN_ROOMS}
                            maxValue={FILTERS_MAX_ROOMS}
                            maxValueAffix="+"
                        />
                    </div>
                </div>
            </div>
        )
    }
})
